import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import AccountIcon from '../icons/AccountIcon';
import styles from './AccountDropdown.module.scss';
const AccountDropdown = ({ className }) => {
    const { user, logout, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const canAccessAdminPortal = Boolean(user?.isStaff ?? user?.is_staff);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const timeoutRef = useRef(undefined);
    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsDropdownOpen(true);
    };
    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setIsDropdownOpen(false);
        }, 100);
    };
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const handleLogout = async () => {
        await logout();
        navigate('/account/login');
    };
    const handleItemClick = (action) => {
        setIsDropdownOpen(false);
        action();
    };
    if (!isAuthenticated) {
        return null;
    }
    return (_jsxs("div", { className: `${styles.accountDropdown} ${className || ''}`, ref: dropdownRef, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [_jsx("div", { className: styles.accountButton, children: _jsx(AccountIcon, { className: styles.accountIcon }) }), isDropdownOpen && (_jsxs("div", { className: styles.dropdownMenu, children: [_jsx("button", { className: styles.dropdownItem, onClick: () => handleItemClick(() => navigate('/clinicDetails')), children: "Account Details" }), _jsx("button", { className: styles.dropdownItem, onClick: () => handleItemClick(() => navigate('/orders')), children: "Orders" }), canAccessAdminPortal && (_jsx("button", { className: styles.dropdownItem, onClick: () => handleItemClick(() => navigate('/web-admin')), children: "Site Admin" })), _jsx("button", { className: styles.dropdownItem, onClick: () => handleItemClick(handleLogout), children: "Logout" })] }))] }));
};
export default AccountDropdown;
